import { InteractiveTable, InteractiveTableCellProps } from '@dreryk/react-components';

import { ReceptionServicePractitionerDisplayName } from '../../receptionServicePractitioner.types';

type ReceptionServicePractitionerDisplayNameCellProps = InteractiveTableCellProps<ReceptionServicePractitionerDisplayName | null> & {
   readonly defaultValue: ReceptionServicePractitionerDisplayName | null;
};

export const ReceptionServicePractitionerDisplayNameCell = (
   props: ReceptionServicePractitionerDisplayNameCellProps
): JSX.Element => {
   return (
      <InteractiveTable.TextViewCell
         testId={props.testId}
         name={props.name}
         index={props.index}
         defaultValue={props.defaultValue}
      />
   );
};
